var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.998,
    height: 24.001,
    viewBox: "0 0 23.998 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "url",
    d: "M6.188,8.719a6.418,6.418,0,0,1,9.889.982l-2.246,2.245A3.385,3.385,0,0,0,10,10a3.33,3.33,0,0,0-1.633.9L4.06,15.2a3.352,3.352,0,0,0,4.74,4.74l1.327-1.327a8.533,8.533,0,0,0,3.779.575l-2.929,2.929a6.43,6.43,0,0,1-9.093-9.093l4.3-4.306Zm6.836-6.836L10.1,4.812a8.534,8.534,0,0,1,3.779.574L15.2,4.06A3.352,3.352,0,0,1,19.94,8.8L15.635,13.1a3.358,3.358,0,0,1-4.74,0,3.567,3.567,0,0,1-.727-1.051L7.922,14.3a6.038,6.038,0,0,0,.8.982,6.423,6.423,0,0,0,9.093,0l4.3-4.305a6.429,6.429,0,1,0-9.091-9.093Z",
    transform: "translate(-0.001 0)",
    fill: "#12233a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.346622e3144f22ddc6d6d345e31fa419.svg";
export { ForwardRef as ReactComponent };